import React, { useRef, useState } from "react";
import "./BecomePartner.css";
import Navber from "../../Components/Navber";
import api from "../../Api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function BecomePartner() {
  const formRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [company_document, setCompany_document] = useState([]);
  const [identityDoc, setIdentityDoc] = useState([]);

  const [formData, setFormData] = useState({
    company_name: "",
    contact_person: "",
    email: "",
    phone: "",
    vendor_type: "",
    experience_years: "",
    description: "",
  });

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateFile = (file) => {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only PDF or image files are allowed");
      return false;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error("File size must be under 5MB");
      return false;
    }

    return true;
  };

  const handleMultipleFiles = (files, setter) => {
    const validFiles = [];
    for (let file of files) {
      if (validateFile(file)) {
        validFiles.push(file);
      }
    }
    setter(validFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (company_document.length === 0 || identityDoc.length === 0) {
      toast.error("Please upload required documents");
      return;
    }

    const data = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      data.append(key, value);
    });

    company_document.forEach((file) => {
      data.append("company_document[]", file);
    });

    identityDoc.forEach((file) => {
      data.append("identity_document[]", file);
    });

    try {
      setLoading(true);

      const res = await api.post("/vendors/apply", data);

      if (res?.data?.status) {
        toast.success("Partner request submitted successfully!");
        e.target.reset();
        setCompany_document([]);
        setIdentityDoc([]);
      } else {
        toast.error("Submission failed. Please try again.");
      }
    } catch (err) {
      console.error(err);
      console.log(err.response?.data?.errors?.email?.[0]);
      toast.error(`${err.response?.data?.errors?.email?.[0]|| "An error occurred"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="partner-page">
      <Navber />
      <ToastContainer position="top-right" />

      {/* HERO */}
      <section className="partner-hero">
        <div className="partner-hero-overlay">
          <h1>Become Our Trusted Partner</h1>
          <p>Grow your business by partnering with us</p>
          <button onClick={scrollToForm}>Become a Partner</button>
        </div>
      </section>

      {/* FORM */}
      <section className="partner-form-section" ref={formRef}>
        <h2>Partner Application Form</h2>

        <form className="partner-form" onSubmit={handleSubmit}>
          <div className="partner-form-grid">
            <input
              name="company_name"
              placeholder="Company Name"
              onChange={handleChange}
              required
            />
            <input
              name="contact_person"
              placeholder="Contact Person"
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email"
              onChange={handleChange}
              required
            />
            <input
              name="phone"
              placeholder="Phone Number"
              onChange={handleChange}
              required
            />

            <select name="vendor_type" onChange={handleChange} required>
              <option value="">Partner Type</option>
              <option value="tour">Tour</option>
              <option value="transport">Transport</option>
              <option value="hotel">Hotel</option>
              <option value="activity">Activity</option>
            </select>

            <input
              type="number"
              name="experience_years"
              placeholder="Experience (Years)"
              min="0"
              onChange={handleChange}
              required
            />
          </div>

          <textarea
            name="description"
            rows="4"
            placeholder="Tell us about your business"
            onChange={handleChange}
            required
          />

          {/* FILE UPLOADS */}
          <div className="file-inputs">
            <label>
              Company Documents ((Image and Pdf only)Multiple)
              <input
                type="file"
                accept="image/*,.pdf"
                multiple
                onChange={(e) =>
                  handleMultipleFiles(e.target.files, setCompany_document)
                }
                required
              />
              {company_document.length > 0 && (
                <small>{company_document.length} file(s) selected</small>
              )}
            </label>

            <label>
              Identity Proof ((Image and Pdf only)Multiple)
              <input
                type="file"
                accept="image/*,.pdf"
                multiple
                onChange={(e) =>
                  handleMultipleFiles(e.target.files, setIdentityDoc)
                }
                required
              />
              {identityDoc.length > 0 && (
                <small>{identityDoc.length} file(s) selected</small>
              )}
            </label>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit Partnership Request"}
          </button>
        </form>
      </section>
    </div>
  );
}
